import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutContent() {
  return (
    <>
      <SEOHead
        title="关于我们 - 黄油下载"
        description="黄油下载是黄油相机爱好者建立的第三方资源分享平台，致力于为用户提供黄油相机官方安全下载渠道和丰富的使用教程。了解我们的品牌故事与联系方式。"
        keywords="黄油下载,关于我们,黄油相机,联系方式"
        canonicalUrl="https://jiruida.cn/about"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: '黄油下载',
          url: 'https://jiruida.cn',
          description: '黄油相机官方安全下载平台',
        }}
      />

      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 黄油下载',
          url: 'https://jiruida.cn/about',
          description: '了解黄油下载的品牌故事、信誉与联系方式',
        }}
      />

      <div className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <div className="mt-4">
          <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">关于我们</h1>
          <p className="text-sm text-foreground-500 mb-12">了解黄油下载的品牌故事与使命</p>
        </div>

        <section className="mb-14">
          <h2 className="text-xl font-heading text-foreground-900 mb-5">品牌介绍</h2>
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              黄油下载成立于2024年，是一个由黄油相机爱好者自发创建的第三方资源分享平台。我们的使命是为广大用户提供<strong>黄油相机官方安全下载渠道</strong>，以及丰富实用的使用教程和技巧分享。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              黄油相机作为国内领先的文字与滤镜美化工具，拥有超过500万用户。我们深知用户在下载和使用过程中可能遇到的困难——安卓用户找不到官方下载渠道、新手不知道如何上手、老用户想了解最新功能却无处查询。黄油下载正是为了解决这些问题而生。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们坚持<strong>安全、可靠、及时</strong>的原则，所有下载链接均来自黄油相机官方渠道，所有教程内容均由经验丰富的黄油相机用户编写。我们希望成为连接黄油相机与用户之间的桥梁，让更多人体验到黄油相机的魅力。
            </p>
          </div>
        </section>

        <section className="mb-14">
          <h2 className="text-xl font-heading text-foreground-900 mb-5">平台信誉</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-2xl">
                <i className="ri-shield-check-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">官方渠道</h3>
              <p className="text-sm text-foreground-500">所有下载链接均来自App Store和官方应用商店，绝不包含第三方修改版本</p>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-2xl">
                <i className="ri-user-heart-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">用户至上</h3>
              <p className="text-sm text-foreground-500">以用户需求为核心，持续更新教程内容和下载资源，解决用户实际问题</p>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-2xl">
                <i className="ri-refresh-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">及时更新</h3>
              <p className="text-sm text-foreground-500">第一时间更新黄油相机最新版本信息和功能教程，保持内容新鲜度</p>
            </div>
          </div>
        </section>

        <section className="mb-14">
          <h2 className="text-xl font-heading text-foreground-900 mb-5">联系方式</h2>
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-600">contact@jiruida.cn</p>
                  <p className="text-xs text-foreground-400 mt-1">工作日24小时内回复</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                  <i className="ri-message-2-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
                  <p className="text-sm text-foreground-600">如发现下载链接失效或内容错误</p>
                  <p className="text-xs text-foreground-400 mt-1">请通过邮箱联系我们修正</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                  <i className="ri-links-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">友情链接</h3>
                  <p className="text-sm text-foreground-600">欢迎优质摄影、设计类网站交换友链</p>
                  <p className="text-xs text-foreground-400 mt-1">请通过邮箱提交友链申请</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                  <i className="ri-file-copy-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">版权声明</h3>
                  <p className="text-sm text-foreground-600">黄油相机版权归北京缪客科技有限公司所有</p>
                  <p className="text-xs text-foreground-400 mt-1">本站为第三方资源分享平台</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 rounded-xl p-6 md:p-8 text-center">
          <h2 className="text-lg font-heading text-foreground-900 mb-3">免责声明</h2>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            本站（黄油下载）为黄油相机爱好者建立的第三方资源分享平台，非黄油相机官方运营网站。黄油相机的商标、版权及相关知识产权均归北京缪客科技有限公司所有。本站提供的下载链接均来自官方渠道，文章内容为用户经验分享，仅供参考。如有任何版权问题，请通过上述联系方式与我们联系，我们将及时处理。
          </p>
        </section>
      </div>
    </>
  );
}